import React from 'react';
import OrderButton from '../../components/common/OrderButton/OrderButton';
import './Focus.less';

class Focus extends React.Component {
  render () {
    return (
      <section className="section section-focus">
        <article className="article-delivery">
          <div className="container-fluid">
            <h4>Dostarczamy w słoiku</h4>
          </div>
        </article>
        <article className="article-heading">
          <div className="container-fluid">
            <h1>
              Gotujemy<br/>
              prawdziwy <em>borszcz</em></h1>
            <h4>od siebie dla Ciebie</h4>
            <div>
              <OrderButton />
            </div>
          </div>
        </article>
        <article className="article-image">
          <figure className="img img-jar" />
        </article>
        <article className="article-story">
          <article className="container-fluid story">
            <header>
              <h1>Więcej niż zupa…</h1>
            </header>
            <p>
              Swieżo przygotowane, aromatyczne i pyszne danie.
            </p>
              <p><strong>Sprawdż to Sam!</strong></p>
            <p>
              Dostarczamy go w słoiku wraz ze śmietaną i ziołami.
            </p>
          </article>
        </article>
      </section>
    );
  }
}

export default Focus;



// WEBPACK FOOTER //
// ./src/components/Focus/Focus.js